import { ITextStyles } from 'flux-definition';
import { DisplayObject, Rectangle } from '@creately/createjs-module';
import * as Carota from '@creately/carota';

/**
 * This is a DisplayObject to render rich texts on the canvas
 */
export class RichText extends DisplayObject {

    /**
     * The width of the text to start text wrapping
     */
    public lineWidth: number;

    /**
     * The Carota document
     */
    protected _doc: any;

    protected width: number = 0;
    protected height: number = 0;

    /**
     * Array of texts data ( carota data structure http://earwicker.com/carota/ )
     * or html string
     */
    protected _text: string | Object[];

    constructor( defaultStyles: ITextStyles ) {
        super()/* istanbul ignore next */;
        this._doc = Carota.document( defaultStyles );
    }

    /**
     * The text value to render, can be either HTML or
     * carota text data structure http://earwicker.com/carota/
     * if the input value is html it will be converted into carota format
     * @param value  Carota text data object or html string
     */
    public set text( value: string | Object[]) {
        this._text =  value;
    }

    /**
     * Sets the default styles for the text
     */
    public setDefaultStyles( value: any ) {
        this._doc.setDefaultStyles( value );
    }

    /**
     * Overrding the easeljs DisplayObject's draw function
     */
    public draw( ctx: CanvasRenderingContext2D, ignoreCache: boolean = false ) {
        if ( !this._text || !this._text.length ) {
            return true;
        }
        if ( super.draw( ctx, ignoreCache )) {
            return true;
        }
        this._doc.load( this._text );
        this._doc.width( this.lineWidth );
        const hasFillColorElement = Array.isArray( this._text ) && this._text.some( ( element: any ) => !!element?.fillColor );

        if ( this._text && this._text[0] && ( this._text[0] as any ).backgroundColor && !hasFillColorElement ) {
            const radius = 5;
            const width = this._doc.frame.actualWidth() > 0 ?
                this._doc.frame.actualWidth() + 2.5 * 2 : this.width + 2.5 * 2;
            const height = Math.floor( this._doc.frame.actualHeight()) === 19 ?
                this.height + 2.5 : this._doc.frame.actualHeight() + 2.5;
            const x = this.getBounds().x - 2.5;
            const y = this.getBounds().y - 1.25;
            ctx.beginPath();
            ctx.moveTo( x + radius, y );
            ctx.arcTo(  x + width, y, x + width, y + height, radius );
            ctx.arcTo( x + width, y + height, x, y + height, radius );
            ctx.arcTo( x, y + height, x, y, radius );
            ctx.arcTo( x, y, x + width, y, radius );
            ctx.closePath();
            ctx.fillStyle = ( this._text[0] as any ).backgroundColor;
            ctx.fill();
        }
        this._doc.draw( ctx );
        return true;
    }

    /**
     * The actual bounds of the text
     * @returns eseljs Rectangle
     */
    public getBounds(): Rectangle {
        return new Rectangle( 0, 0, this._doc.frame.actualWidth(), this._doc.frame.actualHeight());
    }
}
